import { System } from '@ecs/System';
import { HitFlash } from '@components/HitFlash';

export class HitFlashSystem extends System {
  update(_deltaTime: number): void {
    for (const entity of this.getEntitiesWithComponents(HitFlash)) {
      const flash = entity.getComponent(HitFlash)!;
      flash.frames -= 1;
      if (flash.frames <= 0) {
        entity.removeComponent(HitFlash);
      }
    }
  }
}
